function noc(_this) {
  var thisValueLength = _this.val().length;
  var maxlength = _this.attr("maxlength");

  var countDown = maxlength - thisValueLength;
  var countDwnText = "残り" + countDown;
  _this.next().html(countDwnText);
  if (countDown < 0) {
    _this.parent().addClass("over");
  } else {
    _this.parent().removeClass("over");
  }
}

if ($(".js-noc").length > 0) {
  $(document).on("keydown keyup keypress change", ".js-noc", function() {
    noc($(this));
  });
}

$(".js-select-copy").on("change", function() {
  copyGenerator();
});

function copyGenerator() {
  let maincopy = $("#js-select-copy1 option:selected").text();
  let subcopy = $("#js-select-copy2 option:selected").text();
  $("#js-maincopy").val(maincopy);
  $("#js-subcopy").val(subcopy);
  // inputCounterMain.check();
  // inputCounterSub.check();
}

function copyRandom() {
  var randint1 = parseInt(Math.round(Math.random() * ($("#js-select-copy1").children().length - 1)));
  var randint2 = parseInt(Math.round(Math.random() * ($("#js-select-copy2").children().length - 1)));
  $("#js-select-copy1").prop("selectedIndex", randint1);
  $("#js-select-copy2").prop("selectedIndex", randint2);
}

if ($(".js-select-copy").length > 0) {
  // copyRandom();
  // copyGenerator();
}

$("#js-copy-shuffle").on("click", function() {
  copyRandom();
  copyGenerator();
});
